var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowUp = function SvgArrowUp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M8.223 16c.491 0 .89-.398.89-.89V3.037l3.816 3.813a.89.89 0 0 0 1.174.074l.084-.074a.89.89 0 0 0 0-1.257L8.86.269A.9.9 0 0 0 8.223 0L8.3.003 8.253 0h-.03a.9.9 0 0 0-.469.134 1 1 0 0 0-.16.126l.077-.067a1 1 0 0 0-.085.076L2.261 5.592a.889.889 0 1 0 1.257 1.257l3.816-3.815v12.077a.89.89 0 0 0 .786.883z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUp);
export { ForwardRef as ReactComponent };